import licitacao from './LicitacaoApiClient'
import produto from './ProdutoApiClient'
import validarDocumentoApi from './ValidacaoDocumentoApiClient'
import efornecedor from './EfornecedorApiClient'
export default {
    licitacao,
    produto,
    validarDocumentoApi,
    efornecedor
}
